module.exports = [
	{
		"anchor": "about",
		"label": "About me",
		"component": "AboutSection"
	},
	{
		"anchor": "articles",
		"label": "What I've written",
		"component": "ArticlesSection"
	},
	{
		"anchor": "projects",
		"label": "What I've done",
		"component": "ProjectsSection"
	},
	{
		"anchor": "contact",
		"label": "How to reach me",
		"component": "ContactSection"
	}
];


//////////////////
// WEBPACK FOOTER
// ./src/data/sections.json
// module id = 215
// module chunks = 5